<template>
  <v-dialog :value="visible" max-width="60%" persistent>
    <v-card :class="['lightbox']">
      <v-card-title :class="['pa-0', $config.colors.primary]">
        <v-spacer />
        <v-btn @click="visible = false" icon flat aria-label="close-lightbox" :class="['ma-1']" :title="$lang.close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="src" :class="['pa-0']">
        <v-img :lazy-src="$config.replacementImage" :src="src" />
      </v-card-text>
    </v-card>
    <vc-style>
    .v-dialog
      {
        overflow: hidden !important;
      }
    </vc-style>
  </v-dialog>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'Lightbox',
  mixins: [
    methods
  ],
  data () {
    return {
      src: null,
      visible: false
    }
  },
  created () {
    this.$root.$on('show-image-in-lightbox', (data) => {
      this.src = data.src
      this.visible = true
    })
  }
}
</script>
<style>
.lightbox .v-card__text
{
  overflow: auto;
  max-height: 80vh;
}
</style>



// WEBPACK FOOTER //
// src/components/lightbox.vue